export const messagesAdmGenerics = {
    pt: {
        message:{
            access: "Acessar",
            active: "Ativo",
            address:"Endereço",
            city: "Cidade",
            confirmDeactivation:"Confirma desativação?",
            confirmExclusion: "Confirma exclusão?",
            deactivate: "Desativar",
            edition: "Edição",
            establishment: "Estabelecimento",
            id: "ID",
            lastLogin: "Último login",
            neighborhood: "Bairro",
            numberLicences: "Nº de Licenças",
            numberLocals: "Nº de Locais",
            numberActiveCampaigns: "Nº Campanhas Ativas",
            numberEstablishments: "Nº Total Estabs",
            partner: "Parceiro",
            primaryContact: "Contato Primário",
            registration: "Cadastro",
            responsibleName: "Nome do responsável",
            secondaryEmail: "E-mail Secundário",
            secondaryResponsibleName: "Nome do responsável Secundário",
            secondaryContact: "Contato secundário",
            secondaryPhoneNumber: "Telefone Secundário",
            state: "UF",
            street: "Rua",
            streetExtra: "Complemento",
            streetNumber: "Número",
            zipCode: "CEP"
        }
    },
    es: {
        message:{
            access:"Acceso",
            active:"Activo",
            address:"Dirección",
            city:"Ciudad",
            confirmDeactivation:"¿Confirma la desactivación?",
            confirmExclusion:"¿Confirmar la exclusión?",
            deactivate:"Deshabilitar",
            edition:"Edición",
            establishment:"Establecimiento",
            id:"IDENTIFICACIÓN",
            lastLogin:"Último acceso",
            neighborhood:"Barrio",
            numberLicences:"Número de licencias",
            numberLocals:"Número de lugares",
            numberActiveCampaigns: "Número de Campañas Activas",
            numberEstablishments:"Número total estabs",
            partner:"Pareja",
            primaryContact:"Contacto primario",
            registration:"Registro",
            responsibleName:"Nombre del responsable",
            secondaryEmail:"Nombre del responsable secundario",
            secondaryResponsibleName:"Nombre del guardián secundario",
            secondaryContact:"Contacto secundario",
            secondaryPhoneNumber:"Teléfono secundario",
            state:"Depto",
            street:"Calle",
            streetExtra:"Calle Extra",
            streetNumber:"Número",
            zipCode:"CÓDIGO POSTAL"
        }
    },
    en: {
        message:{
            access: "Access",
            active: "Active",
            address:"Address",
            city: "City",
            confirmDeactivation:"Confirm deactivation?",
            confirmExclusion: "Confirm exclusion?",
            deactivate: "Deactivate",
            edition: "Edit",
            establishment: "Establishment",
            id: "ID",
            lastLogin: "Last login",
            neighborhood: "Neighborhood",
            numberLicences: "No. of Licences",
            numberLocals: "No. of Locals",
            numberActiveCampaigns: "No. of Active Campaigns",
            numberEstablishments: "Total No. Estabs",
            partner: "Partner",
            primaryContact: "Primary Contact",
            registration: "Registration",
            responsibleName: "Responsible name",
            secondaryEmail: "Secondary e-mail",
            secondaryResponsibleName: "Secondary responsible name",
            secondaryContact: "Secondary Contact",
            secondaryPhoneNumber: "Secondary phone",
            state: "State",
            street: "Street",
            streetExtra: "Apartment, suite etc",
            streetNumber: "Street number",
            zipCode: "Zip Code"
        }
    }
}
